import { ReduxAction } from 'types/redux';
import { ALERT } from '../../constants/alert.constants';

export function alert(state: any = {}, action: ReduxAction) {
  switch (action.type) {
    case ALERT.SUCCESS:
      return {
        type: ALERT.SUCCESS,
        message: action.message
      };
    case ALERT.WARNING:
      return {
        type: ALERT.WARNING,
        message: action.message
      };
    case ALERT.ERROR:
      return {
        type: ALERT.ERROR,
        message: action.message
      };
    case ALERT.CLEAR:
      return {
        message: '',
      };
    default:
      return state;
  }
}